// src/services/CustomerService.js
import api from "@/services/api";
import authHeader from "./authHeader";

export const customerService = {
  async fetchAllCustomers() {
    return await api.get("/customers", { headers: authHeader() });
  },
  fetchCustomer(id) {
    return api.get(`/customers/${id}`, { headers: authHeader() });
  },
  fetchCreateCustomer(data) {
    return api.post("/customers", data, { headers: authHeader() });
  },
  fetchUpdateCustomer(id, data) {
    return api.put(`/customers/${id}`, data, { headers: authHeader() });
  },
  fetchDeleteCustomer(id) {
    return api.delete(`/customers/${id}`, { headers: authHeader() });
  },
  fetchCustomerSearch(query = "") {
    console.log('ok8');
    return api.get(`/customers/search`, { params: { search: query } });
  },
  fetchCustomerService(id) {
    return api.get(`/customers/${id}/services`, { headers: authHeader() });
  },
};

export default customerService;
